export enum StoryPageType {
    Image = 'image',
    Video = 'video',
    Ads = 'ads',
}

export enum StoryPageDisplay {
    Default = 'default',
    Flow = 'flow',
}
